<template>
    <v-container grid-list-sm>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                    <v-container grid-list-sm>
                        <v-layout row wrap>
                            <v-flex xs2 class="align-self-center">Account Number</v-flex>
                            <v-flex xs4 class="align-self-center">
                                <span class="f-b mr-2">{{ quote.Acc }}</span>
                                <v-chip v-if="quote.DistType" label color="blue-grey darken-1" class="white--text small-tag">{{ quote.DistType }}</v-chip>
                                <v-chip v-if="quote.AccType" label color="lime darken-4" class="white--text small-tag">{{ quote.AccType }}</v-chip>
                                <v-chip v-if="quote.Disc" label color="green darken-2" class="white--text small-tag">{{ quote.Disc }}</v-chip>
                            </v-flex>
                            <v-flex xs2 class="align-self-center">Due Date</v-flex>
                            <v-flex xs4 class="align-self-center f-b text-truncate">{{ $format.dateShort(quote.DueDate) }}</v-flex>
                            <v-flex xs2 class="align-self-center">Company Name</v-flex>
                            <v-flex xs4 class="align-self-center f-b text-truncate">{{ quote.AccName }}</v-flex>
                            <v-flex xs2 class="align-self-center">Quote Number</v-flex>
                            <v-flex xs4 class="align-self-center f-b text-truncate">{{ quote.QNo }}</v-flex>
                            <!-- <v-flex xs2 class="align-self-center">&nbsp;</v-flex>
                            <v-flex xs10 v-if="quote.DistType || quote.AccType || quote.Disc">
                                <v-chip v-if="quote.DistType" label color="blue-grey darken-1" class="white--text small-tag">{{ quote.DistType }}</v-chip>
                                <v-chip v-if="quote.AccType" label color="lime darken-4" class="white--text small-tag">{{ quote.AccType }}</v-chip>
                                <v-chip v-if="quote.Disc" label color="green darken-2" class="white--text small-tag">{{ quote.Disc }}</v-chip>
                            </v-flex> -->
                            <v-flex xs2 class="align-self-center">Fax Number</v-flex>
                            <v-flex xs4 class="align-self-center f-b text-truncate">{{ quote.F }}</v-flex>
                            <v-flex xs2 class="align-self-center">Reference</v-flex>
                            <v-flex xs4 class="align-self-center f-b text-truncate">{{ quote.Ref }}</v-flex>
                            <v-flex xs2 class="align-self-center">Attention</v-flex>
                            <v-flex xs4 class="align-self-center f-b text-truncate">{{ quote.Contact }}</v-flex>
                            <v-flex xs2 class="align-self-center">Page Number</v-flex>
                            <v-flex xs4 class="align-self-center f-b text-truncate">{{ quote.PNo }}</v-flex>
                            <v-flex xs12><v-divider></v-divider></v-flex>
                            <v-flex xs2 class="align-self-center">Comments</v-flex>
                            <!-- <v-flex xs10 class="f-b"><span v-html="escapeText(quote.Comment)"></span></v-flex> -->
                            <v-flex xs10 class="el-p-0" v-html="quote.Comment"></v-flex>
                            <v-btn absolute dark fab bottom right color="accent" @click="editCoverData" v-show="quote.S_Id==='DRAFT'">
                                <v-icon>edit</v-icon>
                            </v-btn>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-flex>
            <v-flex xs12>
                <v-card class="mt-3 pl-1 pr-1">
                    <v-data-table :headers="headers" :items="quote.Items" :loading="isBusy" hide-actions class="table-padding-small table-even-odd">
                        <template slot="items" slot-scope="props">
                            <tr @click="onSelect(props.item)">
                                <td class="text-xs-right">
                                    <v-checkbox v-model="props.item.Selected" hide-details v-show="!props.item.Err && quote.S_Id==='DRAFT'" class="chk-selector"></v-checkbox>
                                    <v-tooltip top v-show="props.item.Err && quote.S_Id==='DRAFT'">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-show="props.item.Err && quote.S_Id==='DRAFT'" v-on="on" color="orange darken-2" class="qx-ico-warn">warning</v-icon>
                                        </template>
                                        <span>{{ props.item.Err }}</span>
                                    </v-tooltip>
                                </td>
                                <td class="text-xs-right">{{ props.item.Idx }}.</td>
                                <td><v-text-field placeholder="Description" v-model="props.item.Desc" class="f-n f-bm grid-input" flat solo single-line hide-details background-color="transparent" :readonly="props.item.RType !== 'FRC' || quote.S_Id!=='DRAFT'" @blur="calcTotals"></v-text-field></td>
                                <td>
                                    <v-menu v-model="props.item.IdInOpPop" open-on-hover offset-y :close-on-content-click="true">
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" :loading="props.item.IdInOpLoad" flat icon :color="stockIdColour(props.item)"><v-icon>{{ props.item.IdInOp === undefined ? 'remove' : (props.item.IdInOp ? 'check' : 'notification_important') }}</v-icon></v-btn> <!-- not_interested -->
                                        </template>
                                        <v-card>
                                            <v-container fill-height fluid pa-2 dark :class="`white--text ${stockIdColour(props.item)}`">
                                                {{ props.item.IdInOp === undefined ? 'Stock ID check pending' : (props.item.IdInOp ? 'Stock ID check has passed' : 'The stock ID does not seem to exist') }}
                                            </v-container>
                                            <v-card-title>
                                                <table>
                                                    <tr><td>Stock Id</td><td class="pl-1 font-weight-bold">{{ props.item.StockId }}</td></tr>
                                                    <tr><td>Analysis Code</td><td class="pl-1 font-weight-bold">{{ props.item.Anal }}</td></tr>
                                                </table>
                                            </v-card-title>
                                        </v-card>
                                    </v-menu>
                                </td>
                                <td><span class="qx-item-type">{{ props.item.RType }}</span></td>
                                <td><v-text-field v-model="props.item.Unit" class="f-n f-bm grid-input" flat solo single-line hide-details background-color="transparent" :readonly="true" @blur="calcTotals"></v-text-field></td>
                                <td><v-numeric v-model="props.item.Qty" class="f-n f-bm grid-input el-text-center" flat solo single-line hide-details background-color="transparent" number-type="number" :readonly="quote.S_Id!=='DRAFT'" @blur="calcTotals"></v-numeric></td>
                                <td><v-numeric v-model="props.item.Price" class="f-n f-bm grid-input el-text-right" flat solo single-line hide-details background-color="transparent" :readonly="props.item.RType !== 'FRC' || quote.S_Id!=='DRAFT'" @blur="calcTotals" number-type="currency"></v-numeric></td>
                                <!-- <td><v-numeric placeholder="1" v-model="props.item.CPerc" class="f-n f-bm grid-input el-text-right" flat solo single-line hide-details background-color="transparent" :readonly="quote.S_Id!=='DRAFT'" :disabled="$CONST.CUSTOM_DISC.indexOf(props.item.RType) > -1" @blur="calcTotals" number-type="percent"></v-numeric></td> -->
                                <td class="text-xs-right">
                                    <span v-if="quote.S_Id !== 'DRAFT'">{{ props.item.FinalPerc ? (Number.isInteger(props.item.FinalPerc) ? $format.percentInt(props.item.FinalPerc) : $format.percent(props.item.FinalPerc)) : '-' }}</span>
                                    <span v-else-if="$CONST.CUSTOM_DISC.indexOf(props.item.RType) > -1">-</span>
                                    <v-numeric v-else :placeholder="customerDiscHolder()" v-model="props.item.CPerc" class="f-n f-bm grid-input el-text-right" flat solo single-line hide-details :always-show-value="false" background-color="transparent" :readonly="quote.S_Id!=='DRAFT'" :disabled="$CONST.CUSTOM_DISC.indexOf(props.item.RType) > -1" @blur="calcTotals" number-type="percent"></v-numeric>
                                </td>
                                <td class="text-xs-right">{{ $format.currency(props.item.NetPrice) }}</td>
                                <td class="text-xs-right">{{ $format.currency(props.item.OpTotal) }}</td>
                                <td class="text-xs-center"><v-icon class="qx-ico-more" v-show="quote.S_Id==='DRAFT'">more_vert</v-icon></td>
                            </tr>
                        </template>
                        <template slot="no-data">
                            <v-subheader>No products.</v-subheader>
                        </template>
                    </v-data-table>
                    <v-fab-transition>
                        <v-btn v-show="quote.S_Id==='DRAFT' && flaggedRecords" absolute dark fab bottom right color="error" @click="show">
                            <v-icon>remove</v-icon>
                        </v-btn>
                    </v-fab-transition>
                    <v-fab-transition>
                        <v-btn v-show="quote.S_Id==='DRAFT' && !flaggedRecords" absolute dark fab bottom right color="accent" @click="show">
                            <v-icon>add</v-icon>
                        </v-btn>
                    </v-fab-transition>
                    <!-- <v-btn absolute dark fab bottom right :color="showDeleteItemButton ? 'error' : 'accent'" @click="show">
                        <v-icon>{{ flaggedRecords ? "remove" : "add" }}</v-icon>
                    </v-btn> -->
                    <v-menu absolute offset-y :position-x="mx" :position-y="my" v-model="addMenu">
                        <v-list>
                            <v-list-tile v-for="(item, index) in addMenuItems" :key="index" class="list-auto-h" @click="onAddMenu(item)" v-show="item.show">
                                <v-list-tile-sub-title>{{ item.value }}</v-list-tile-sub-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                    <!-- <v-btn absolute dark fab bottom right color="accent">
                        <v-icon>add</v-icon>
                    </v-btn> -->
                    <v-divider></v-divider>
                    <div class="el-clearfix">
                        <div class="pt-1 pb-1 el-float-right" style="margin-right: 66px;">
                            <div>
                                <span class="qx-total-lbl">Total Ex VAT</span><span class="qx-total-val el-text-right">{{ $format.currency(quote.SubTotal) }}</span>
                            </div>
                            <div>
                                <span class="qx-total-lbl">VAT @ {{ VatAt }}%</span><span class="qx-total-val el-text-right">{{ $format.currency(quote.Vat) }}</span>
                            </div>
                            <div>
                                <span class="qx-total-lbl b-t f-b">Total</span><span class="qx-total-val b-t f-b el-text-right">{{ $format.currency(quote.Total) }}</span>
                            </div>
                        </div>
                    </div>
                    <v-divider></v-divider>
                    <div class="el-clearfix" v-show="quote.S_Id==='DRAFT'">
                        <div class="pt-2 pb-1 el-float-left">
                            <v-btn v-for="(item, index) in addMenuItems" :key="index" color="primary" v-show="item.show" small outline :value="item.value" @click="onAddMenu(item)">{{ item.value }}</v-btn>
                        </div>
                    </div>
                </v-card>
            </v-flex>
            <v-flex xs12>
                <v-card class="mt-3">
                    <v-container grid-list-sm class="pa-3">
                        <v-layout row wrap>
                            <v-btn @click="onCreate" color="primary" v-show="quote.S_Id==='DRAFT'">Create</v-btn>
                            <v-btn @click="onSave" v-show="quote.S_Id==='DRAFT'">Save</v-btn>
                            <v-btn @click="onNewFrom" v-show="quote.S_Id!=='DRAFT'">Create New From</v-btn>
                            <v-btn @click="onEmail" :disabled="quote.S_Id==='DRAFT'">Email</v-btn>
                            <v-btn @click="onPrint" :disabled="quote.S_Id==='DRAFT'">Print</v-btn>
                            <v-btn @click="onBackClick">Back</v-btn>
                            <v-btn icon @click="showHelpDialog = true"><v-icon>live_help</v-icon></v-btn>
                            <v-btn icon @click="showDiscountDialog = true"><v-icon>legend_toggle</v-icon></v-btn>
                            <v-spacer></v-spacer>
                            <v-btn @click="onDelete" :loading="isBusyError" color="error" v-show="quote._id">Delete</v-btn>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-flex>
            <v-flex xs12 v-if="quote.RetryLog">
                <v-alert :value="true" type="error" outline v-html="quote.RetryLog.replace(/\r\n/g, '<br/>')"></v-alert>
            </v-flex>
            <v-flex xs12>
                <v-container style="max-width: 600px;">
                    <v-timeline dense clipped>
                        <v-timeline-item fill-dot class="mb-5" color="primary" large>
                            <template v-slot:icon>
                                <span class="white--text">QH</span>
                            </template>
                            <span class="subheading">Quote History</span>
                        </v-timeline-item>
                        <v-slide-x-transition group>
                            <v-timeline-item v-for="event in quote.Hist" :key="event._id" class="mb-3" :color="event.Clr" small>
                                <v-layout justify-space-between>
                                    <v-flex xs12>
                                        <div class="f-b f-m primary--text">{{ event.Name }}<span class="pl-2 f-b f-m grey--text">{{ $format.dateTime(event.Dt) }}</span></div>
                                        <div>{{ event.Msg }}</div>
                                        <!-- <div class="f-b f-s grey--text">{{ event.Dt }}</div> -->
                                    </v-flex>
                                    <!-- <v-flex xs5 text-xs-right f-b f-s grey--text v-text="event.Dt"></v-flex> -->
                                </v-layout>
                            </v-timeline-item>
                        </v-slide-x-transition>
                        <!-- <v-timeline-item class="mb-4" hide-dot>
                            <span>TODAY</span>
                        </v-timeline-item> -->
                    </v-timeline>
                </v-container>
            </v-flex>
        </v-layout>
        <v-dialog v-model="showCoverDialog" persistent max-width="900px">
            <v-card>
                <v-card-title>
                    <span class="headline">Customer &amp; Data</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-sm class="pa-0">
                        <v-layout row wrap>
                            <v-flex xs6>
                                <v-text-field label="Account Number" v-model="coverData.Acc"></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                                <v-menu :close-on-content-click="false" v-model="showDate" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                    <v-text-field slot="activator" v-model="coverData.DueDateStr" label="Due Date" readonly></v-text-field>
                                    <v-date-picker v-model="coverData.DueDateStr" @input="showDate=false"></v-date-picker>
                                </v-menu>
                                <!-- <v-text-field label="Due Date" v-model="coverData.DueDate"></v-text-field> -->
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field label="Company Name" v-model="coverData.AccName"></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field label="Quote Number" v-model="coverData.QNo" disabled></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field label="Fax Number" v-model="coverData.F"></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field label="Reference" v-model="coverData.Ref"></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field label="Attention" v-model="coverData.Contact"></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field label="Page Number" v-model="coverData.PNo"></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <div class="caption grey--text text--darken-1">Comment</div>
                                <!-- <v-textarea label="Comments" v-model="coverData.Comment"></v-textarea> -->
                                <quill-editor v-model="coverData.Comment" ref="richComment" :options="editorOption"></quill-editor>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pa-3">
                    <v-btn color="primary" @click="onCoverUpdate">Update</v-btn>
                    <v-btn @click="showCoverDialog=false">Close</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showNonStockDialog" :fullscreen="$vuetify.breakpoint.xsOnly" persistent max-width="900px">
            <v-card>
                <v-card-title>
                    <span class="headline">Non Stock Items</span>
                </v-card-title>
                <v-card-text class="pt-0">
                    <v-container grid-list-sm class="pa-0">
                        <v-layout row wrap style="min-height: 550px;">
                            <v-flex xs4>
                                <div class="el-clearfix">
                                    <div class="pt-2 pb-1 el-float-left subheading">
                                        Select Unit
                                    </div>
                                </div>
                                <v-divider></v-divider>
                                <v-text-field v-model="searchUnit" placeholder="Filter Units" append-icon="search" @keyup.native="unitChange"></v-text-field>
                                <v-data-table :headers="headersNonStock" :items="dataNonStockGroups" :loading="isLookupBusy" hide-actions hide-headers class="table-padding-small table-even-odd">
                                    <template slot="items" slot-scope="props">
                                        <tr @click="onSelectUnit(props.item)">
                                            <td :class="`${props.item.Sel ? ' f-b blue-grey lighten-4' : ''}`">{{ props.item.CN_DESC }}</td>
                                        </tr>
                                    </template>
                                    <template slot="no-data">
                                        <v-subheader>No records.</v-subheader>
                                    </template>
                                </v-data-table>
                                <!-- <v-btn-toggle v-model="nonStockGroup" mandatory @change="loadStockData">
                                    <v-btn small v-for="item in dataNonStockGroups" :key="item._id" flat :value="item.CN_REF">{{ item.CN_REF }}</v-btn>
                                </v-btn-toggle> -->
                            </v-flex>
                            <v-flex xs8 pl-2>
                                <div class="el-clearfix">
                                    <div class="pt-2 pb-1 el-float-left subheading">
                                        Select Product
                                    </div>
                                </div>
                                <v-divider></v-divider>
                                <v-text-field ref="productSearch" v-model="searchText" placeholder="Type to search for products" append-icon="search" :loading="isLookupBusy" @keyup.native="searchChange"></v-text-field>
                                <v-data-table :headers="headersStock" :items="dataStock" :loading="isLookupBusy" hide-actions hide-headers class="table-padding-small table-even-odd">
                                    <template slot="items" slot-scope="props">
                                        <tr @click="onSelectStock(props.item)">
                                            <td>{{ props.item.CN_DESC }}</td>
                                        </tr>
                                    </template>
                                    <template slot="no-data">
                                        <v-subheader>No products.</v-subheader>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pa-3">
                    <v-btn color="primary" @click="onSelectWithoutStock">No Stock Item</v-btn>
                    <v-btn @click="showNonStockDialog=false">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <span>Displaying first 15 product matches.</span>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showHelpDialog" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable max-width="600px">
            <v-card>
                <v-card-title class="headline info white--text" primary-title><v-icon large dark class="pr-3">help</v-icon>Button Action Explanation</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="max-height: 500px;">
                    <v-layout row wrap>
                        <v-flex xs3 f-b text-uppercase>Create</v-flex>
                        <v-flex xs9>Saves and creates the quote. A quote number is generated with the option to email the customer. The quote becomes "fixed" and cannot be edited anymore. If it is recalled and edited at a later stage, a new quote will be created from it.</v-flex>
                        <v-flex xs12 pt-3 pb-3><v-divider></v-divider></v-flex>
                        <v-flex xs3 f-b text-uppercase>Save</v-flex>
                        <v-flex xs9>Saves the quote to be recalled for edit at a later stage. Saved quotes cannot be sent to a customer.</v-flex>
                        <v-flex xs12 pt-3 pb-3><v-divider></v-divider></v-flex>
                        <v-flex xs3 f-b text-uppercase>Email</v-flex>
                        <v-flex xs9>Once a quote has been "created", it can be emailed to a customer as a PDF document.</v-flex>
                        <v-flex xs12 pt-3 pb-3><v-divider></v-divider></v-flex>
                        <v-flex xs3 f-b text-uppercase>Print</v-flex>
                        <v-flex xs9>Once a quote has been "created", it can be printed. The PDF document will be opened, which can then be printed.</v-flex>
                        <v-flex xs12 pt-3 pb-3><v-divider></v-divider></v-flex>
                        <v-flex xs3 f-b text-uppercase>Back</v-flex>
                        <v-flex xs9>Navigates back to the previous screen. Also acts as a cancel button.</v-flex>
                        <v-flex xs12 pt-3 pb-3><v-divider></v-divider></v-flex>
                        <v-flex xs3 f-b text-uppercase>Delete</v-flex>
                        <v-flex xs9>Deletes a saved or created quote. Quotes are never really deleted but are marked as deleted which hides it from the system.</v-flex>
                    </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="primary" @click="showHelpDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showDiscountDialog" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable max-width="400px">
            <v-card>
                <v-card-title class="headline info white--text" primary-title><v-icon large dark class="pr-3">help</v-icon>Discount Structure</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-layout>
                        <v-flex row v-for="disc in DISC_STRUCT" :key="disc._id">
                            <v-layout column>
                                <v-flex xs6 text-xs-center>{{ $format.currencyInt(disc.Name) }}</v-flex>
                                <v-flex xs6 text-xs-center>{{ disc.Value }} %</v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="primary" @click="showDiscountDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showEmailDialog" :fullscreen="$vuetify.breakpoint.xsOnly" persistent max-width="900px">
            <v-card>
                <v-card-title>
                    <span class="headline">Email Quote as PDF</span>
                </v-card-title>
                <v-card-text class="pt-0">
                    <v-container grid-list-sm class="pa-0">
                        <v-layout row wrap ill-height style="min-height: 500px;">
                            <v-flex xs12>
                                <!-- <v-text-field v-model="email.to" :rules="[email.rules.required, email.rules.email]" label="Email Address" ></v-text-field> -->
                                <v-combobox v-model="email.to" :rules="[email.rules.required]" :items="this.customerEmails" label="Email Address"></v-combobox>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="email.subject" :rules="[email.rules.required]" label="Subject" ></v-text-field>
                            </v-flex>
                            <v-flex xs12 class="qx-email">
                                <quill-editor v-model="email.message" ref="richText" :options="editorOption"></quill-editor>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pa-3">
                    <v-btn color="primary" @click="onEmailSend">Send</v-btn>
                    <v-btn @click="showEmailDialog=false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="isDialogBusy" persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    Processing...
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import { format } from 'date-fns';
import Constants from '../../util/Constants';
import Data from '../../util/Data';
import Numeric from '../../controls/Numeric';

export default {
    name: 'Quote',
    components: {
        quillEditor,
        'v-numeric': Numeric
    },
    data() {
        return {
            title: 'Quote',
            user: { has: () => 0 },
            ViewCompany: {},
            isBusy: false,
            isLookupBusy: false,
            isBusyError: false,
            isDialogBusy: false,
            addMenu: false,
            mx: 0,
            my: 0,
            selectedCustomer: {},
            customerEmails: [],
            quote: { Items: [], Hist: [] },
            coverData: {
                Acc: '',
                DueDate: new Date(),
                DueDateStr: new Date().toISOString().substr(0, 10),
                AccName: '',
                QNo: '',
                F: '',
                Ref: '',
                Contact: '',
                PNo: '1',
                Comment: ''
            },
            headers: [
                { text: '', value: 'Selected', align: 'left', sortable: false, width: '30px' },
                { text: 'Item', value: 'Idx', align: 'right', sortable: false, width: '40px' },
                { text: 'Description', value: 'Desc', align: 'left', sortable: false },
                { text: '', value: 'IdInOp', align: 'center', sortable: false, width: '40px' },
                { text: '', value: 'RType', align: 'left', sortable: false, width: '40px' },
                { text: 'Unit', value: 'Unit', align: 'left', sortable: false, width: '60px' },
                { text: 'Quantity', value: 'Qty', align: 'center', sortable: false, width: '70px' },
                { text: 'Price', value: 'Price', align: 'right', sortable: false, width: '80px' },
                { text: 'Disc %', value: 'CPerc', align: 'right', sortable: false, width: '60px' },
                { text: 'Net Price', value: 'NetPrice', align: 'right', sortable: false, width: '80px' },
                { text: 'Total', value: 'Total', align: 'right', sortable: false, width: '120px' },
                { text: 'More', value: 'More', align: 'center', sortable: false, width: '60px' }
            ],
            showCoverDialog: false,
            showDate: false,
            addMenuItems: [
                { key: 'STD', value: 'Standard Price List', show: true },
                { key: 'INT', value: 'Interactive', show: true },
                { key: 'FRC', value: 'Free Capture', show: true },
                { key: 'CRP', value: 'C.R.P', show: false },
                { key: 'MIN', value: 'Mining', show: false },
                // { key: 'STP', value: 'Strip Calculator' },
                // { key: 'COS', value: 'Costing Program' }
                // { key: 'IAR', value: 'Interactive Ring' },
                // { key: 'IAF', value: 'Interactive Full Face' },
            ],
            // nonStockGroup: null,
            searchUnit: '',
            dataNonStockGroupsRaw: [],
            dataNonStockGroups: [],
            headersNonStock: [
                { text: 'Unit', value: 'CN_REF', align: 'left', sortable: false },
            ],
            searchText: '',
            dataStock: [],
            headersStock: [
                { text: 'Product', value: 'CN_DESC', align: 'left', sortable: false },
            ],
            showNonStockDialog: false,
            showHelpDialog: false,
            showDiscountDialog: false,
            showDeleteItemButton: false,
            showEmailDialog: false,
            editorOption: {
                modules: {
                    toolbar: [
                        [{ size: ['small', false, 'large', 'huge'] }],
                        ['bold', 'italic', 'underline', 'strike'],
                        [{ color: [] }, { background: [] }, 'clean'],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        [{ script: 'sub' }, { script: 'super' }],
                        [{ indent: '-1' }, { indent: '+1' }],
                        [{ align: [] }, 'link'],
                    ]
                }
            },
            email: {
                to: '',
                subject: '',
                message: '',
                rules: {
                    required: value => !!value || 'Required.',
                    counter: value => value.length <= 20 || 'Max 20 characters',
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        return pattern.test(value) || 'Invalid e-mail.';
                    }
                }
            },
            settings: [],
            DISC_STRUCT: [],
            VatAt: 0,
            VAT: 0,
            VAT_INCL: 0,
            normalDiscount: 0
        };
    },
    computed: {
        flaggedRecords() {
            this.showDeleteItemButton = this.quote.Items.reduce((acc, cur) => acc + (cur.Selected || 0), 0) > 0;
            return this.showDeleteItemButton;
        }
    },
    mounted() {
        this.$root.$on('CompanySwitched', () => {
            this.ViewCompany = this.$ls.get('ViewCompany', {});
            this.loadData();
        });
        this.$root.$on('QuoteSwitch', switchTo => {
            // The switch happens between New and Session quote and vice versa.
            if (switchTo === 'Session' && this.ContextQuote.Items) {
                this.quote = this.ContextQuote;
            }
            else {
                this.initNewQuote();
            }
            this.calcTotals();
        });

        this.user = this.$ls.get('User');
        Object.defineProperty(this.user, 'has', { value: this.$has });
        this.ViewCompany = this.$ls.get('ViewCompany', {});
        this.selectedCustomer = this.ContextCustomer || {};

        if (this.ContextCustomer.SN_ORDMAIL) this.customerEmails.push(this.ContextCustomer.SN_ORDMAIL);
        if (this.ContextCustomer.SN_EMAIL) this.customerEmails.push(this.ContextCustomer.SN_EMAIL);

        if (this.selectedCustomer.CUST_TYPE === 'C.R.P.') this.addMenuItems.find(o => o.key === 'CRP').show = true;
        if (this.selectedCustomer.CUST_TYPE === 'MINING') this.addMenuItems.find(o => o.key === 'MIN').show = true;

        if (this.$route.query.Q_Id) {
            this.loadQuote(this.$route.query.Q_Id);
        }
        else if (this.$router.currentRoute.name === 'QuoteSession' && this.ContextQuote.Items) {
            this.quote = this.ContextQuote;
        }
        else {
            this.initNewQuote();
        }

        // If products are passed, add them to the quote.
        if (this.$route.query.product) {
            const products = this.$route.query.product.data;
            const ptype = this.$route.query.product.type;
            switch (ptype) {
                case 'STD': this.addFromStandard(products, ptype); break;
                case 'CRP': this.addFromStandard(products, ptype); break;
                case 'INT': this.addFromInteractive(products); break;
                default: break;
            }
            this.setIndexes();
        }

        this.loadLookups();
    },
    methods: {
        async loadLookups() {
            try {
                this.isLookupBusy = true;
                const settings = await this.$http.post('/Settings/quote', { C_Id: this.ViewCompany._id, CU_Id: this.quote._id });
                this.settings = settings.data.d;

                // Discount brackets.
                this.DISC_STRUCT = [];
                const dist = this.settings.filter(o => o.Group === 'Discount');
                for (let i = 0; i < dist.length; i++) {
                    const copy = JSON.parse(JSON.stringify(dist[i])); // Make a copy.
                    copy.Name = parseInt(copy.Name, 10); // Conver the name, which is a number, to int.
                    this.DISC_STRUCT.push(copy);
                }
                Data.sort(this.DISC_STRUCT, 'Name');
                this.DISC_STRUCT.reverse();

                // VAT.
                const sett = this.settings.find(o => o.Group === 'VAT' && o.Name === 'VAT');
                this.VatAt = sett.Value;
                if (!this.quote.VatAt) {
                    this.quote.VatAt = sett.Value;
                    this.VAT = sett.Value / 100;
                }
                else {
                    this.VAT = this.quote.VatAt / 100;
                }
                this.VAT_INCL = this.VAT + 1;
                // this.isLookupBusy = false;
                this.calcTotals();
                this.loadNonStock(); // Load last as it might not be used straight away.
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the data.' });
            }
        },
        async loadNonStock() {
            try {
                const stock = await this.$http.post('/Stock/non-stock', { C_Id: this.ViewCompany._id });
                this.dataNonStockGroupsRaw = stock.data.d;
                this.dataNonStockGroups = this.dataNonStockGroupsRaw;
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'Failed to load Non Stock data.' });
            }
            this.isLookupBusy = false;
        },
        async loadStockData() {
            this.isLookupBusy = true;
            try {
                const stock = await this.$http.post('/Stock/search', { C_Id: this.ViewCompany._id, search: this.searchText, multiSpace: true, _page: { per: 15, page: 1 } });
                this.dataStock = stock.data.d;
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'Failed to load Non Stock data.' });
            }
            this.isLookupBusy = false;
        },
        async loadQuote(id) {
            this.isDialogBusy = true;
            try {
                const response = await this.$http.get(`/Quote/${id}`);
                if (!response.data.s) {
                    this.$alert({ type: 'error', title: 'Load Quote Failed', message: 'An error has occurred. Please contact your systems administrator.' });
                    return;
                }
                response.data.d.DueDateStr = response.data.d.DueDate.substr(0, 10);
                // If the quote is not in DRAFT status, set the Stock ID check to done.
                if (response.data.d.S_Id !== 'DRAFT') {
                    response.data.d.Items.forEach(item => {
                        item.IdInOp = true;
                    });
                }
                this.quote = response.data.d;
                // If the quote is in DRAFT status, check the Stock IDs.
                if (response.data.d.S_Id === 'DRAFT') {
                    this.checkStockCodes();
                }
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Load Quote Failed', message: `An error occurred trying to load the quote. ${err.message}` });
            }
            this.isDialogBusy = false;
        },
        initNewQuote() {
            this.quote = {
                C_Id: this.ViewCompany._id,
                CU_Id: this.selectedCustomer._id,
                Acc: this.selectedCustomer.SN_ACCOUNT,
                AccName: this.selectedCustomer.SN_NAME,
                Contact: this.selectedCustomer.SN_CONTACT,
                // AccInfo: String,
                T: this.selectedCustomer.SN_ORDTEL, // Telephone.
                F: this.selectedCustomer.SN_ORDFAX, // Fax.
                M: this.selectedCustomer.SN_CONTACT, // Mobile.
                E: this.selectedCustomer.SN_ORDMAIL, // Email.
                QNo: '[Generated on create]', // Quote number.
                Ref: '000000', // Document number.
                PNo: '1', // Page number.
                DueDate: new Date(),
                DueDateStr: new Date().toISOString().substr(0, 10),
                AccType: this.selectedCustomer.CUST_TYPE, // CRP etc.
                DistType: this.selectedCustomer.DIST_TYPE,
                Disc: this.selectedCustomer.DISC, // Customer discount
                IsCOD: false, // Is a COD customer.
                Items: [],
                SubTotal: 0,
                Vat: 0,
                Total: 0,
                VatAt: this.VatAt,
                Hist: [{ _id: 0, U_Id: this.user._id, Name: this.user.DN, Msg: 'New quote pending save.', Clr: 'grey lighten-2', Dt: new Date() }], // '20 Aug 2019 - 10:22'
                S_Id: 'DRAFT', // Status code. DRAFT / DONE
                Comment: 'Thank you for your enquiry, we take pleasure in offering you the following as outlined below:\nPrices quoted are net and exclusive of VAT, unless detailed below:',
                U_Id: this.user._id
            };
        },
        unitChange() {
            if (!this.searchUnit) this.dataNonStockGroups = this.dataNonStockGroupsRaw;
            else {
                const reg = new RegExp(`(${this.searchUnit.split(',').join(')|(')})`, 'gi');
                this.dataNonStockGroups = this.dataNonStockGroupsRaw.filter(o => reg.test(o.CN_REF));
            }
        },
        searchChange() {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                this.loadStockData();
            }, 600);
        },
        onSelectUnit(row) {
            this.dataNonStockGroups.forEach(o => {
                if (o.Sel) {
                    o.Sel = false;
                    const idx = this.dataNonStockGroups.indexOf(o);
                    this.$set(this.dataNonStockGroups, idx, o);
                }
            });
            row.Sel = true;
            const idx = this.dataNonStockGroups.indexOf(row);
            this.$set(this.dataNonStockGroups, idx, row);
            this.$refs.productSearch.focus();
        },
        onSelectStock(row) {
            const unit = this.dataNonStockGroups.find(o => o.Sel === true);
            if (!unit) {
                this.$alert({ type: 'warning', title: 'No Unit', message: 'Please select a unit before selecting a product.' });
                return;
            }
            this.addFromFree(row);
            this.setIndexes();
        },
        onSelectWithoutStock() {
            const unit = this.dataNonStockGroups.find(o => o.Sel === true);
            if (!unit) {
                this.$alert({ type: 'warning', title: 'No Unit', message: 'Please select a unit.' });
                return;
            }
            this.addFromFree(null);
            this.setIndexes();
        },
        show(evt) {
            if (this.showDeleteItemButton) { // The button is acting as a delete/remove of items.
                this.removeSelected();
                return;
            }
            if (this.addMenu) return;
            evt.preventDefault();
            this.addMenu = false;
            const pos = evt.target.getBoundingClientRect();
            this.mx = pos.left; // evt.clientX;
            this.my = pos.top + pos.height; // evt.clientY;
            this.$nextTick(() => {
                this.addMenu = true;
            });
        },
        onAddMenu(item) {
            switch (item.key) {
                case 'STD':
                    this.$router.push({ name: 'PriceList' });
                    break;
                case 'CRP':
                    this.$router.push({ name: 'CRP' });
                    break;
                case 'INT':
                    this.$router.push({ name: 'Interactive' });
                    break;
                case 'FRC':
                    this.showNonStockDialog = true;
                    break;
                case 'STR':
                case 'COS':
                    this.$alert({ title: 'To be implemented', message: 'To be implemented' });
                    break;
                default: break;
            }
        },
        removeSelected() {
            const len = this.quote.Items.length - 1;
            for (let i = len; i >= 0; i--) {
                if (this.quote.Items[i].Selected) {
                    this.quote.Items.splice(i, 1);
                }
            }
            this.calcTotals();
        },
        setIndexes() {
            this.quote.Items.forEach((p, i) => {
                p.Idx = i + 1;
                if (!p.Anal) p.Err = 'No analysis code!'; // Warn if no analysis code.
                else p.Err = '';
            });
        },
        addFromFree(product) {
            const unit = this.dataNonStockGroups.find(o => o.Sel === true);
            if (unit.CN_REF.endsWith('---')) unit.CN_REF = unit.CN_REF.substr(0, unit.CN_REF.length - 3);
            let userUnitCode = '';
            let fullDesc = '';
            if (unit.CN_DESC.toUpperCase() === 'EA') { // If EA then use the user's EA if available.
                userUnitCode = (this.user.EA || 'EA').toUpperCase();
                fullDesc = product ? product.CN_REF : `${unit.CN_REF}${userUnitCode.substr(2)}`;
            }
            else {
                fullDesc = unit.CN_REF;
            }
            this.quote.Items.push({
                Idx: 1,
                StockId: fullDesc,
                Anal: product ? product.CN_ANAL : unit.CN_ANAL,
                RType: 'FRC', // Rec type
                CPerc: '', // Manual discount percent
                Desc: product ? product.CN_DESC : '',
                Unit: userUnitCode || unit.CN_DESC,
                Qty: 1,
                Price: 0,
                NetPrice: 0,
                Total: 0,
                OpTotal: 0,
                IdInOpLoad: true,
                Err: ''
            });
            this.showNonStockDialog = false;
            this.calcTotals();
            // const refs = [fullDesc];
            this.checkStockCodes();
        },
        addFromStandard(products, ptype) {
            const NON_STOCK = 'NON STOCK';
            products.forEach(p => {
                let stock = '';
                let anal = '';
                const code = p.Item;
                if (code) {
                    anal = code.substr(16);
                    stock = code.substr(0, 16);
                    if (stock.startsWith(NON_STOCK)) {
                        stock = stock.replace(/-/g, '');
                    }
                }
                this.quote.Items.push({
                    Idx: 1,
                    StockId: stock, // Opera
                    Anal: anal, // Opera
                    RType: ptype, // STD or CRP
                    CPerc: '', // Manual discount percent
                    Desc: p.Desc,
                    Unit: p.Unit,
                    Qty: 1,
                    Price: p.Price,
                    NetPrice: p.Price,
                    Total: p.Price,
                    OpTotal: 0,
                    IdInOpLoad: true,
                    Err: (!code || !anal) ? 'No analysis code' : ''
                });
            });
            this.checkStockCodes();
        },
        addFromInteractive(products) {
            const unitCode = (this.user.EA || 'EA').toUpperCase();
            products.forEach(p => {
                this.quote.Items.push({
                    Idx: 1,
                    StockId: p.CN_REF, // Opera
                    Anal: p.CN_ANAL, // Opera
                    RType: p.Type,
                    CPerc: '', // Manual discount percent
                    Desc: p.Desc === 'NON STOCK EA' ? `${p.Desc}${unitCode.substr(2)}` : p.Desc,
                    Unit: unitCode,
                    Qty: 1,
                    Price: p.PRICE,
                    NetPrice: p.PRICE,
                    Total: p.PRICE,
                    OpTotal: 0,
                    IdInOpLoad: true,
                    Err: ''
                });
            });
            this.checkStockCodes();
        },
        async checkStockCodes() {
            const todo = this.quote.Items.filter(o => o.IdInOp === undefined);
            todo.forEach(async t => {
                t.IdInOpLoad = true;
            });
            setTimeout(() => { this.checkStockCodesEx(todo); }, 500);
        },
        async checkStockCodesEx(todo) {
            const query = { C_Id: this.ViewCompany._id };
            await todo.forEach(async t => {
                try {
                    query.REF = [t.StockId];
                    const stock = await this.$http.post('/Stock/valid-code', query);
                    const data = stock.data.d[0];
                    t.IdInOp = data.Good;
                    delete t.IdInOpLoad;
                }
                catch (err) {
                    console.error(err);
                }
            });
            // Remove the busy indicator if there are any missed items.
            const flagged = this.quote.Items.filter(o => o.IdInOpLoad);
            flagged.forEach(o => {
                o.IdInOpLoad = false;
            });
            setTimeout(() => {
                this.quote.Items = this.quote.Items.slice(); // Trigger UI update. Sometimes lags behind.
            }, 500);
        },
        stockIdColour(item) {
            if (item.IdInOpLoad) return 'info';
            if (item.IdInOp === undefined) return 'warning';
            return item.IdInOp ? 'success' : 'error';
        },
        onSelect(row) {
            const target = window.event.target;
            const chk = target.closest('.chk-selector');
            if (chk) return;
            else if (target.className.indexOf('qx-ico-warn') > -1) {
                this.$prompt({ title: 'Enter Alalysis Code', message: 'Enter the Analysis Code for this product:', value: '' }, result => {
                    if (result.Action) {
                        if (`${result.Value}`.trim() === '') return;
                        row.Anal = result.Value;
                        row.Err = '';
                    }
                });
                return;
            }
            else if (target.className.indexOf('qx-ico-more') > -1) {
                // console.warn('More info on product.');
                return;
            }
            console.warn('SELECTED');
        },
        customerDiscHolder() {
            return this.quote.Disc || this.normalDiscountDisplay || '0%';
        },
        calcTotals() {
            if (this.quote.S_Id !== 'DRAFT') return;
            // 1. Total all the CRPs, Mining and Discounted prices and normal prices separately.
            // 2. Get the discount on the normal total.
            // 3. Calculate the net price and then the final total.
            // 4. Display sub total, VAT and final total.

            // 1. ----------------------------------
            let allSum = 0;
            let normalSum = 0;
            // let otherSum = 0;
            this.quote.Items.forEach(o => {
                // Sort out currency rounding. Done to prevent long numbers sent to Opera.
                o.Price = this.financial(o.Price);
                // o.NetPrice = this.financial(o.NetPrice);
                // Total is price * quantity.
                o.Total = this.financial((o.Price || 0) * (o.Qty || 0));
                o.hasPerc = (o.CPerc !== '' && o.CPerc !== undefined && o.CPerc !== null) || (this.quote.Disc !== '' && this.quote.Disc !== undefined && this.quote.Disc !== null && this.quote.Disc !== '');

                if (Constants.CUSTOM_DISC.indexOf(o.RType) > -1 || o.hasPerc) { // CRP, MINE or custom discount.
                    // Total the free capture prices.
                    // otherSum += o.Total;
                }
                else {
                    // Total the other prices.
                    normalSum += o.Total;
                }
            });

            // 2. ----------------------------------
            // Calculate the discount structure on the free capture.
            this.normalDiscountDisplay = '';
            let normalDiscount = 0;
            let normalPercent = 0;
            const dcs = this.DISC_STRUCT.find(o => o.Name <= normalSum);
            if (dcs) {
                normalDiscount = dcs.Value;
                this.normalDiscountDisplay = this.$format.percent(dcs.Value);
            }
            /* this.DISC_STRUCT.forEach(o => {
                if (normalSum >= o.Name) {
                    normalDiscount = o.Value;
                    this.normalDiscountDisplay = this.$format.percent(o.Value);
                }
            }); */
            if (normalDiscount > 0) {
                normalDiscount = 1 - (normalDiscount / 100);
                normalPercent = normalDiscount;
            }
            else {
                normalDiscount = 1;
                normalPercent = 0;
            }

            // 3. ----------------------------------
            let anyDiscount = 1;
            this.quote.Items.forEach(o => {
                if (Constants.CUSTOM_DISC.indexOf(o.RType) > -1) anyDiscount = 1; // CRP, MINE already has its own discount.
                else if (o.hasPerc) { // Custom discount.
                    if (o.CPerc !== '' && o.CPerc !== undefined && o.CPerc !== null) {
                        anyDiscount = 1 - (o.CPerc / 100);
                        o.FinalPerc = o.CPerc;
                    }
                    else if (this.quote.Disc !== undefined && this.quote.Disc !== null && this.quote.Disc !== '') {
                        anyDiscount = 1 - (parseFloat(this.quote.Disc) / 100);
                        o.FinalPerc = parseFloat(this.quote.Disc);
                    }
                }
                else {
                    anyDiscount = normalDiscount;
                    o.FinalPerc = normalPercent;
                }

                // Net price.
                o.NetPrice = this.financial((o.Price || 0) * anyDiscount);
                // Final total is net price * quantity.
                o.OpTotal = this.financial((o.NetPrice || 0) * (o.Qty || 0));
                o.Total = o.OpTotal;

                allSum += o.OpTotal;
            });

            // 4. ----------------------------------
            // Sub Total.
            this.quote.SubTotal = this.financial(allSum);

            // VAT.
            this.quote.Vat = this.financial(allSum * this.VAT);

            // Total.
            this.quote.Total = this.financial(allSum * this.VAT_INCL);

            this.$quote(this.quote); // Store in session.
        },
        onNewFrom() {
            /* if (!Object.keys(this.ContextCustomer).length) {
                this.$alert({ type: 'warning', title: 'Select a Customer', message: 'A customer must first be selected before a quote can be created. The customer name should be highlighted in the footer bar.' });
                return;
            } */
            const optionItems = [
                `Use the context customer that is highlighted in the footer bar? ${this.ContextCustomer.SN_NAME || '(None Selected)'}`,
                `Use the customer that is already on this quote? ${this.quote.AccName}`,
                'Cancel new quote creation'
            ];
            const options = {
                title: 'New Quote From?',
                message: 'Which customer do you want to use for the new quote. Choose another customer in the customer list to have it listed as an option here.',
                options: optionItems,
                value: ''
            };
            this.$prompt(options, async value => {
                if (value.Action) {
                    const pos = optionItems.indexOf(value.Value);
                    if (pos < 0 || pos > 1) return;
                    if (pos === 0) {
                        if (!this.ContextCustomer.SN_NAME) {
                            this.$alert({ type: 'warning', title: 'Select a Customer', message: 'A customer must first be selected before a quote can be created. The customer name should be highlighted in the footer bar.' });
                            return;
                        }
                        this.selectedCustomer = this.ContextCustomer;
                        this.quote.Acc = this.selectedCustomer.SN_ACCOUNT;
                        this.quote.AccName = this.selectedCustomer.SN_NAME;
                        this.quote.Contact = this.selectedCustomer.SN_CONTACT;
                        this.quote.T = this.selectedCustomer.SN_ORDTEL; // Telephone.
                        this.quote.F = this.selectedCustomer.SN_ORDFAX; // Fax.
                        this.quote.M = this.selectedCustomer.SN_CONTACT; // Mobile.
                        this.quote.E = this.selectedCustomer.SN_ORDMAIL; // Email.
                        this.quote.AccType = this.selectedCustomer.CUST_TYPE; // CRP etc.
                        this.quote.DistType = this.selectedCustomer.DIST_TYPE; // Discount type.
                        this.quote.Disc = this.selectedCustomer.DISC; // Customer discount

                        // Go through the product items and remove special prices.
                        const products = [];
                        this.quote.Items.forEach(o => {
                            if (Constants.CUSTOM_DISC.indexOf(o.RType) === -1) {
                                delete o.CPerc;
                                products.push(o);
                            }
                        });
                        this.quote.Items = products;
                        setTimeout(() => { this.calcTotals(); });
                    }
                    /* const res = await this.$http.delete(`/Survey/${this.item._id}?all-data=${pos}`);
                    if (res.data.s) {
                        this.onCancel();
                    }
                    else this.$error(this.$t('general.delete_error'), this.$t('general.an_error')); */
                    this.quote.QNo = '[Generated on create]'; // Quote number.
                    this.quote.Ref = '000000'; // Document number.
                    this.quote.PNo = '1'; // Page number.
                    this.quote.DueDate = new Date();
                    this.quote.DueDateStr = new Date().toISOString().substr(0, 10);
                    this.quote.IsCOD = false; // Is a COD customer.
                    this.quote.Hist = [{ _id: 0, U_Id: this.user._id, Name: this.user.DN, Msg: 'New quote pending save.', Clr: 'grey lighten-2', Dt: new Date() }];
                    this.quote.S_Id = 'DRAFT'; // Status code. DRAFT / DONE
                    this.quote.Comment = 'Thank you for your enquiry, we take pleasure in offering you the following as outlined below:\nPrices quoted are net and exclusive of VAT, unless detailed below:';
                    this.quote.U_Id = this.user._id;
                    this.$alert({ type: 'info', title: 'New Quote From', message: `This is a new quote with the same product items except for CRPs, using customer ${this.quote.AccName}.` });
                }
            });
        },
        financial(value) {
            return Number.parseFloat(value).toFixed(2) * 1;
        },
        checkNonStock() {
            this.quote.Items.forEach(p => {
                if (p.StockId.startsWith('NON STOCK')) {
                    p.StockId = p.StockId.replace(/-/g, '');
                }
            });
        },
        async onCreate() {
            if (!this.quote.Items.length) {
                this.$alert({ type: 'warning', title: 'No Products', message: 'Please add products before creating a quote.' });
                return;
            }
            this.isDialogBusy = true;
            try {
                this.quote.Hist = [];
                this.checkNonStock();
                const response = await this.$http.post('/Quote/create', this.quote);
                if (!response.data.s) {
                    this.$alert({ type: 'error', title: 'Create Failed', message: 'An error has occurred. Please contact your systems administrator.' });
                    return;
                }
                this.quote = response.data.d;
                this.$confirm({
                    title: 'Email?',
                    message: 'Send the quote to the customer?'
                }, value => {
                    if (value) {
                        this.onEmail();
                    }
                });
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Create Error', message: `An error occurred trying to save the data. ${err.message}` });
            }
            this.isDialogBusy = false;
        },
        async onSave() {
            if (!this.quote.Items.length) {
                this.$alert({ type: 'warning', title: 'No Products', message: 'Please add products before saving a quote.' });
                return;
            }
            this.isDialogBusy = true;
            try {
                if (!this.quote._id) this.quote.Hist = [];
                this.checkNonStock();
                const response = await this.$http.post('/Quote/draft', this.quote);
                if (!response.data.s) {
                    this.$alert({ type: 'error', title: 'Save Failed', message: 'An error has occurred. Please contact your systems administrator.' });
                    return;
                }
                this.quote = response.data.d;
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Save Error', message: `An error occurred trying to save the data. ${err.message}` });
            }
            this.isDialogBusy = false;
        },
        onEmail() {
            this.email.to = this.user.E; // this.quote.E; // this.customer.SalesOrderEmail // SN_ORDMAIL
            this.email.subject = `JMP Quote ${this.quote.QNo} - ${format(new Date(), 'EEEE, PPP')}`;
            this.email.message = `Dear ${this.quote.Contact},<br/><br/>` +
                `Please find attached Quote <b>${this.quote.QNo}</b>.<br/><br/>` + // for R {2}
                'Please contact me should you have any queries.<br/><br/>' +
                'Regards,<br/><br/>' +
                `<b>${this.user.DN}</b> | JMP Sales Department<br/>` +
                'John Moffat Prolock (Pty) Ltd<br/>' +
                '<a href="http://www.jmp.co.za" rel="noopener noreferrer" target="_blank">www.jmp.co.za</a>';
            // this.customer.OrderContact, this.data.QuoteNo, this.ui.qteTotal.text(), this._user ? this._user.FullName || "Sales" : "Sales"
            this.showEmailDialog = true;
        },
        async onEmailSend() {
            // Remove the wrapping <p> tag.
            const html = [];
            this.email.message.split('<p>').forEach(l =>
                (l.startsWith('<br></p>') ?
                    html.push('<br/>') :
                    html.push(l.replace(/<\/p>/g, '<br/>')))
            );
            this.showEmailDialog = false;
            // this.isDialogBusy = true;
            this.$process({ show: true, message: 'Sending email ...' });
            try {
                if (!this.quote._id) this.quote.Hist = [];
                const email = {
                    to: this.email.to,
                    subject: this.email.subject,
                    message: html.join(''),
                    text: this.$refs.richText.quill.getText()
                };
                const response = await this.$http.post('/Quote/send', { C_Id: this.ViewCompany._id, QNo: this.quote.QNo, email });
                if (!response.data.s) {
                    this.showEmailDialog = true;
                    this.$alert({ type: 'error', title: 'Email Error', message: `An error occurred trying to send the email. ${response.data.m}` });
                    return;
                }
                this.$alert({ type: 'success', title: 'Email Sent', message: `Email was sent to ${this.email.to}` });
                this.loadQuote(this.quote._id);
            }
            catch (err) {
                console.error(err);
                this.showEmailDialog = true;
                this.$alert({ type: 'error', title: 'Email Error', message: `An error occurred trying to send the email. ${err.message}` });
            }
            finally {
                // this.isDialogBusy = false;
                this.$process({ show: false });
            }
        },
        onPrint() {
            //
        },
        onDelete() {
            this.$confirm({
                title: 'Delete?',
                message: 'Are you sure you want to delete this quote?'
            }, value => {
                if (value) {
                    this.onDeleteAction();
                }
            });
        },
        async onDeleteAction() {
            this.$process({ show: true, message: 'Deleting ...' });
            try {
                const response = await this.$http.post('/Quote/delete', { C_Id: this.ViewCompany._id, _id: this.quote._id }); // Can delete by QNo or _id
                this.$process({ show: false });
                if (!response.data.s) {
                    this.showEmailDialog = true;
                    this.$alert({ type: 'error', title: 'Delete Error', message: `An error occurred trying to delete the quote. ${response.data.m}` });
                    return;
                }
                this.$alert({ type: 'success', title: 'Deleted', message: `Quote ${!this.quote.QNo || this.quote.QNo === '[Generated on create]' ? this.quote._id : this.quote.QNo} has been deleted.` });
                this.$router.push({ name: 'QuoteList' });
            }
            catch (err) {
                console.error(err);
                this.$process({ show: false });
                this.$alert({ type: 'error', title: 'Delete Error', message: `An error occurred trying to delete the quote. ${err.message}` });
            }
        },
        editCoverData() {
            this.coverData.Acc = this.quote.Acc;
            this.coverData.DueDate = this.quote.DueDate;
            this.coverData.DueDateStr = this.quote.DueDateStr;
            this.coverData.AccName = this.quote.AccName;
            this.coverData.QNo = this.quote.QNo;
            this.coverData.F = this.quote.F;
            this.coverData.Ref = this.quote.Ref;
            this.coverData.Contact = this.quote.Contact;
            this.coverData.PNo = this.quote.PNo;
            this.coverData.Comment = this.quote.Comment;

            this.showCoverDialog = true;
        },
        onCoverUpdate() {
            this.quote.Acc = this.coverData.Acc;
            this.quote.DueDate = new Date(this.coverData.DueDateStr);
            this.quote.DueDateStr = this.coverData.DueDateStr;
            this.quote.AccName = this.coverData.AccName;
            this.quote.QNo = this.coverData.QNo;
            this.quote.F = this.coverData.F;
            this.quote.Ref = this.coverData.Ref;
            this.quote.Contact = this.coverData.Contact;
            this.quote.PNo = this.coverData.PNo;
            /* console.log(this.coverData.Comment);
            console.log(this.coverData.Comment.split('<p>'));
            // Remove the wrapping <p> tag.
            const html = [];
            // this.coverData.Comment = this.coverData.Comment.substr(3, this.coverData.Comment.length - 7);
            this.coverData.Comment.split('<p>').forEach(l =>
                (l.startsWith('<br></p>') ?
                    html.push('<br/>') :
                    html.push(l.replace(/<\/p>/g, '<br/>')))
            );
            this.quote.Comment = html.join(''); */
            // x.split(/(?=<p)|(?=<\/p>)/)
            // x.split(/(?=<[^>]*>)/)
            this.quote.Comment = this.coverData.Comment;

            this.showCoverDialog = false;
        },
        escapeText(txt) {
            if (!txt) return '';
            return txt.replace(/\n/g, '<br/>');
        },
        onBackClick() {
            window.history.back();
            // this.$router.push({ name: 'QuoteList' });
        }
    }
};
</script>

<style>
.qx-ico-warn { cursor: help; }
.qx-ico-more { cursor: pointer; }
.qx-item-type {
    background-color: #BBB;
    color: #FFF;
    font-size: 80%;
    font-weight: 700;
    padding: 0px 2px;
}
.qx-total-lbl { display: inline-block; width: 80px; }
.qx-total-val { display: inline-block; width: 150px; }
.qx-email .quill-editor {
    height: 350px;
}
.qx-email .quill-editor .ql-container.ql-snow {
    max-height: 305px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Quote/Quote.vue